<template>
  <v-dialog v-model="dialog" max-width="600">
    <template v-slot:activator="{ on }">
      <ButtonTooltip
        v-on="on"
        color="error"
        icon="delete"
        type="delete"
        :tooltip="$t('adminVideo.buttons.deleteFile')"
        @click.native="openDialog"
        :disabled="disabled"
      />
    </template>
    <v-card>
      <v-card-title class="headline">{{ $t('adminVideo.deleteDialog.title') }}</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-0 mt-5 subtitle-2">{{ supprText }}</v-card-text>
      <v-card-text class="subtitle-2">{{ $t('adminVideo.deleteDialog.noFoundBack') }}</v-card-text>
      <v-card-text class="subtitle-4">{{ $t('adminVideo.deleteDialog.hint') }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="dialog = false"> {{ $t('common.cancel') }} </v-btn>
        <v-btn color="primary" text @click="deleteFile"> {{ $t('common.accept') }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ButtonTooltip from '@/components/adminVideo/ButtonTooltip'

export default {
  name: 'ButtonTooltipDelete',

  components: {
    ButtonTooltip
  },

  props: ['disabled', 'indexName'],

  data() {
    return {
      dialog: false
    }
  },

  computed: {
    supprText() {
      if (this.indexName === 'introduction') return this.$t('adminVideo.deleteDialog.introVideoMessage')
      if (this.indexName === 'conclusion') return this.$t('adminVideo.deleteDialog.outroVideoMessage')
      if (this.indexName === 'audio') return this.$t('adminVideo.deleteDialog.audioMessage')
      return ''
    }
  },

  methods: {
    openDialog(type) {
      if (this.disabled) return
      this.dialog = true
    },

    deleteFile() {
      this.dialog = false
      this.$emit('upload-size-error', false)
      this.$store.dispatch('adminVideo/deleteMedia', this.indexName)
    }
  }
}
</script>
